

















import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class UTruncate extends Vue {
  // Props

  @Prop({ required: true })
  public text!: string;

  @Prop({ required: false, default: 200 })
  public limit!: number;

  @Prop({ required: false, default: 20 })
  public buffer!: number;

  @Prop({ required: false, default: "span" })
  public tag!: string;

  @Prop({ required: false, default: null })
  public action!: string;

  @Prop({ required: false, default: "javascript:void(0);" })
  public href!: string;

  @Prop({ default: true })
  public hasWhiteSpacePreWrap!: boolean;

  // Data

  public isTruncated = true;

  // Computed

  public get truncatedText() {
    if (this.text === null) return "";
    const text = this.text;
    const truncated = text.substr(0, text.lastIndexOf(" ", this.limit));
    if (truncated.length + this.buffer >= text.length) return text;
    return truncated;
  }
  public get canTruncate() {
    return this.text !== null && this.truncatedText.length < this.text.length;
  }
  // Methods
  public onClick($event) {
    $event.stopPropagation();
    // If parent has .click listener – simply emit event
    if (this.$_.has(this.$listeners, "click")) {
      return this.$emit("click", $event);
    }
    // Otherwise toggle truncated text
    this.isTruncated = !this.isTruncated;
  }
}
